import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import "./AdminDashboard.css";

import Dashboard from "./Dashboard";
import ManageUsers from "./ManageUsers";
import UpdatePortfolio from "./UpdatePortfolio";
import ManageCompanies from "./ManageCompanies";
import ManageCurrency from "./ManageCurrency";

const AdminDashboard = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activePage, setActivePage] = useState("dashboard");
  const navigate = useNavigate(); // Initialize navigate

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  // Logout handler
  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/"); // Redirect to home/login page
  };

  const renderContent = () => {
    switch (activePage) {
      case "dashboard":
        return <Dashboard />;
      case "users":
        return <ManageUsers />;
      case "portfolio":
        return <UpdatePortfolio />;
      case "companies":
        return <ManageCompanies />;
      case "currency":
        return <ManageCurrency />;
      default:
        return <Dashboard />;
    }
  };

  return (
    <div className="admin-dashboard">
      {/* Topbar for mobile */}
      <div className="topbar">
        <button className="menu-toggle" onClick={toggleMenu}>
          ☰
        </button>
        <div className="topbar-brand">
          <img src="/firstbench-logo.png" alt="FirstBench Logo" className="logo" />
          <h1 className="admin-header">Admin</h1>
        </div>
      </div>

      {/* Overlay when menu is open */}
      {menuOpen && <div className="overlay" onClick={closeMenu}></div>}

      {/* Sidebar */}
      <div className={`sidebar ${menuOpen ? "visible" : ""}`}>
        <div className="sidebar-header">
          <img src="/firstbench-logo.png" alt="FirstBench Logo" className="logo" />
          <h1 className="admin-header">Admin</h1>
        </div>

        <ul className="nav">
          <li
            className={activePage === "dashboard" ? "active" : " "}
            onClick={() => {
              setActivePage("dashboard");
              closeMenu();
            }}
          >
            📊 Dashboard
          </li>
          <li
            className={activePage === "users" ? "active" : ""}
            onClick={() => {
              setActivePage("users");
              closeMenu();
            }}
          >
            👥 Manage Users
          </li>
          <li
            className={activePage === "portfolio" ? "active" : ""}
            onClick={() => {
              setActivePage("portfolio");
              closeMenu();
            }}
          >
            🛠️ Update Portfolio
          </li>
          <li
            className={activePage === "companies" ? "active" : ""}
            onClick={() => {
              setActivePage("companies");
              closeMenu();
            }}
          >
            🏢 Manage Brokers
          </li>
          <li
            className={activePage === "currency" ? "active" : ""}
            onClick={() => {
              setActivePage("currency");
              closeMenu();
            }}
          >
            💱 Manage Currency
          </li>

          <li
            onClick={() => {
              closeMenu();
              navigate("/investor-report");
            }}
          >
            📈 Investor Report
          </li>

          <li onClick={handleLogout}>🚪 Logout</li>
        </ul>
      </div>

      {/* Main Content */}
      <div className="main-content">{renderContent()}</div>
    </div>
  );
};

export default AdminDashboard;
